module.exports = __webpack_public_path__ + "static/img/dynamicsbanner.37542e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/dynamicsbanner.png
// module id = HEpg
// module chunks = 0